import { useMemo, useState } from 'react'
import { useApplication } from 'src/context/application'
import {
  ApplicationBodyContainer,
  ApplicationBodyContent,
  DefaultTitle,
} from 'src/components/application/defaultComponents'
import ApplicationPrebuiltFooter from 'src/components/application/PrebuiltBodyFooter'
import PastLiabilityForm from 'src/components/application/judges/newBusiness/PastLiabilityForm'
import { ValidationError } from 'yup'
import ApplicationData from 'src/dtos/applicationData'
import { JudgeLiabilitySchema } from 'src/yup/NewAppSchema'

const PastLiability = () => {
  const { application } = useApplication()
  const [pastLiability, setPastLiability] = useState(
    application?.judgeApplicationData?.insuranceSection?.pastLiability
  )
  const [isIncorrect, setIsIncorrect] = useState(false)

  const updatedApplicationData = (): ApplicationData => ({
    ...application,
    currentPage: window.location.pathname,
    judgeApplicationData: {
      ...application?.judgeApplicationData,
      insuranceSection: {
        ...application?.judgeApplicationData?.insuranceSection,
        pastLiability: {
          ...application?.judgeApplicationData?.insuranceSection,
          ...pastLiability
        }
      }
    }
  })

  const validatePage = () => {
    try {
      JudgeLiabilitySchema.validateSync({...pastLiability}, { abortEarly: false })
      return []
    } catch(e) {
      const { errors } = e as ValidationError

      return errors
    }
  }

  const beforeSaveContinueClick = () => {
    const validation = validatePage()
    if(validation.length > 0) {
      setIsIncorrect(true)
      document.getElementById(validation[0])?.scrollIntoView({ behavior: 'smooth' })
      return
    }
  }

  const nextRoute = () => {
    if(pastLiability?.hasActsToBaseClaim === true || pastLiability?.hasClaimsAsserted === true) {
      return '/judge/insurance/claims'
    }
    return '/judge/quote/details'
  }

  return (
    <ApplicationBodyContainer>
      <ApplicationBodyContent>
        <DefaultTitle>Let’s look at any past liability.</DefaultTitle>
        <PastLiabilityForm
          pastLiability={pastLiability}
          setPastLiability={setPastLiability}
          isIncorrect={isIncorrect}
          validatedFields={validatePage()}
        />
      </ApplicationBodyContent>
      <ApplicationPrebuiltFooter
        goBackRoute="/judge/insurance/last-insurances"
        isFormValid={validatePage().length === 0}
        nextRoute={nextRoute()}
        updatedApplication={updatedApplicationData()}
        beforeSaveContinueClick={beforeSaveContinueClick}
      />
    </ApplicationBodyContainer>
  )
}

export default PastLiability